import Vue from 'vue';
import Vuex from 'vuex';
import axios from '@/app-axios';
import { subscribeToPush } from '../utils/push';

// Module imports
import { alert } from './modules/alert.module';
import { decision } from './modules/decision.module';
import { swiftuser } from './modules/swiftuser.module';
import { questions } from './modules/questions.module';
import { register } from './modules/register.module';
import { userprofile } from './modules/userprofile.module';
import { passcodereset } from './modules/passcodereset.module';
import { projects } from './modules/projects.module';
import { organization } from './modules/organization.module';
import { appusers } from './modules/appusers.module';
import { company } from './modules/company.module';
import { countries } from './modules/countries.module';
import { devices } from './modules/devices.module';
import { jobs } from './modules/jobs.module';
import { invoice } from './modules/invoice.module';
import { timesheets } from './modules/timesheets.module';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    device: null,
    selectedOrg: null,
    worker: {},
  },
  mutations: {
    setUserData (state, userData) {
      state.user = userData;
      localStorage.setItem('user', JSON.stringify(userData));
      axios.defaults.headers.common.Authorization = `Bearer ${userData.token}`;
    },

    setSeletedOrganization (state, userData) {
      state.selectedOrg = userData;
      localStorage.setItem('selectedOrganization', JSON.stringify(userData));
    },

    setDeviceData (state, deviceData) {
      state.device = deviceData.kiosk;
      localStorage.setItem('device', JSON.stringify(deviceData));
      axios.defaults.headers.common.Authorization = `Bearer ${deviceData.token}`;
    },

    setKioskUserData (state, kioskUserData) {
      state.worker = kioskUserData;
      localStorage.setItem('worker', JSON.stringify(kioskUserData));
      axios.defaults.headers.common.Authorization = `Bearer ${kioskUserData.token}`;
    },
    setClearWorkerTokenAndAssign () {
      const deviceData = JSON.parse(localStorage.getItem('device'));
      if (deviceData && deviceData.token) {
        axios.defaults.headers.common.Authorization = `Bearer ${deviceData.token}`;
      }
    },

    clearUserData () {
      localStorage.removeItem('user');
      localStorage.removeItem('checkInTime');
      localStorage.removeItem('checkIn');
      localStorage.removeItem('worker');
      localStorage.removeItem('selectedOrganization');
      location.reload();
    },

    clearDeviceUserData () {
      localStorage.removeItem('device');
    },

    clearKioskUserData () {
      localStorage.removeItem('worker');
    },
  },
  actions: {
    login ({ commit }, credentials) {
      return axios.post('api/devices/login', credentials).then(({ data }) => {
        commit('setUserData', data);
        if (data.organizations.length !== 0) {
          commit('setSeletedOrganization', data.organizations[0]);
        }
        if ('serviceWorker' in navigator && 'PushManager' in window) {
          subscribeToPush();
        }
      });
    },

    deviceLogin ({ commit }, credentials) {
      return axios.post('api/kiosks/login', credentials).then(({ data }) => {
        commit('setDeviceData', data);
      });
    },

    loginKioskUser ({ commit }, payload) {
      return axios
        .post('api/kiosks/app-users/login', payload.loginDetails)
        .then(({ data }) => {
          commit('setKioskUserData', data);
        });
    },

    logout ({ commit }) {
      commit('clearUserData');
    },
    clearWorkerTokenAndAssignKioskToken ({ commit }) {
      commit('setClearWorkerTokenAndAssign');
    },

    deviceLogout ({ commit }) {
      commit('clearDeviceUserData');
    },

    kioskUserLogout ({ commit }) {
      commit('clearKioskUserData');
    },
  },

  getters: {
    isLogged: (state) => !!state.user,
    getUser (state) {
      return state.user;
    },

    getSelectedOrganization (state) {
      return state.selectedOrg;
    },

    getDeviceData (state) {
      return state.device;
    },

    getWorker (state) {
      return state.worker;
    },

    getFirstOrganization (state) {
      return state.user;
    },
  },

  modules: {
    alert,
    decision,
    questions,
    swiftuser,
    register,
    userprofile,
    passcodereset,
    projects,
    organization,
    appusers,
    company,
    countries,
    devices,
    jobs,
    invoice,
    timesheets,
  },
});
